<template>
  <div class="page-wrapper">
    <div class="   container-custom  heading-wrapper">
      <div class="venous-center-heading-image d-flex justify-content-center align-items-center">
        <div class="heading-content ">
          <div class="heading-title"> {{ heading.title }}</div>
          <div class="d-flex justify-content-center">
            <div class="heading-description"> {{ heading.description }}</div>
          </div>
          <div class="d-flex justify-content-center">
            <a href="#thumbnails">
              <MainButton :button-text="$t('learn-more')" :size="'medium'" :theme="'solid-white'"/>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="highlight-box-wrapper container-custom ">
      <div class="row g-3">
        <div v-for="(highlight, index) in highlights" :key="index" class="highlight-box col-md-3 col-6">
          <HighlightIconBox :icon="highlight.icon" :title="highlight.title"/>
        </div>
      </div>

    </div>
    <div id="thumbnails" class="thumbnails-wrapper ">
      <div class="">
        <div class="heading-title-container container-custom">
          <div class="title">{{ services.title }}</div>
          <div class="description">{{ services.paragraph1 }}</div>
          <div class="description">{{ services.paragraph2 }}</div>
        </div>
        <div class="grid-container container-custom d-none d-md-flex ">
          <div v-for="(thumbnail, index) in thumbnails" :key="index" class="grid-item-5-2">
            <div class="inner-grid-item">
              <OneServiceThumbnail
                  :img-src="thumbnail.imgSrc"
                  :title="thumbnail.title"
                  @click="showModal(thumbnail.id)"
              />
            </div>
          </div>
        </div>
        <div class="d-md-none services-mobile-carousel mt-5 ">
          <Carousel :breakpoints="breakpoints" v-bind="settings">
            <slide v-for="(thumbnail, index) in thumbnails" :key="index">
              <OneServiceThumbnail
                  :img-src="thumbnail.imgSrc"
                  :title="thumbnail.title"
                  @click="showModal(thumbnail.id)"
              />
            </slide>

          </carousel>
        </div>
      </div>


    </div>
    <div class="services-wrapper ">
      <div class="container-custom">
        <div class="title"> {{ $t('venous-center-additional-services-title') }}</div>
        <div class="row g-3">
          <div v-for="(service, index) in additionalServices" :key="index" class="col-md-6">
            <OneServiceCategoryButton :buttonText="service.title" :theme="'solid-grey'" @click="showModal(service.id)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalMain ref="modalComponent"
             :title="venousService ? venousService.title : ''"
             size="large">
    <div>
      <div class="modal-content-body" v-html="venousService.content"></div>
    </div>
  </ModalMain>
</template>

<script>


import HighlightIconBox from "@/components/Components/HIghlightIconBox/HighlightIconBox.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import OneServiceThumbnail from "@/components/Components/OneServiceThumbnail/OneServiceThumbnail.vue";
import OneServiceCategoryButton from "@/components/Common/Buttons/OneServiceCategoryButton.vue";
import {Carousel, Slide,} from 'vue3-carousel'
import ModalMain from "@/components/Components/ModalMain/ModalMain.vue";

export default {
  name: 'VenousCenterView',
  components: {
    ModalMain,
    Slide,
    Carousel,
    OneServiceCategoryButton,
    OneServiceThumbnail,
    MainButton,
    HighlightIconBox
  },
  data() {
    return {
      heading: {},
      highlights: [],
      services: {},
      thumbnails: [],
      additionalServices: [],
      venousService: null,
      allServices: [],
      settings: {
        itemsToShow: 1.5,
        snapAlign: 'start',

      },
      breakpoints: {
        // 770px and up
        770: {
          itemsToShow: 3.5,
          snapAlign: 'center',
        },
        // 1024 and up
        1024: {
          itemsToShow: 5,
          snapAlign: 'start',
        },
      },
    };
  },
  async mounted() {
    this.heading = {
      title: this.$t('venous-center-heading-title'),
      description: this.$t('venous-center-heading-description'),

    };
    this.highlights = [
      {
        title: this.$t('venous-center-highlight-1'),
        icon: 'technology'
      },
      {
        title: this.$t('venous-center-highlight-2'),
        icon: 'doctor'
      },
      {
        title: this.$t('venous-center-highlight-3'),
        icon: 'leg'
      },
      {
        title: this.$t('venous-center-highlight-4'),
        icon: 'care'
      },
    ];

    this.services = {
      title: this.$t('venous-center-services-title'),
      paragraph1: this.$t('venous-center-services-paragraph-1'),
      paragraph2: this.$t('venous-center-services-paragraph-2'),
    };

    this.allServices = await this.$store.dispatch("venousServices/getVenousServices");

    this.additionalServices = this.allServices.filter((item) => {
      return item.highlight === false;
    });

    this.thumbnails = this.allServices.filter((item) => {
      return item.highlight === true;
    });
  },
  methods: {
    showModal(id) {
      let service = null
      this.allServices.forEach((item) => {
        if (item.id === id) {
          service = item;
        }
      });
      if (!service) {
        return;
      }
      this.venousService = service;
      this.$refs.modalComponent.showModal();
    },
  },

};

</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
  margin-top: 90px;
  color: $color-brown;
}

.heading-wrapper {
  .venous-center-heading-image {
    height: 600px;
    border-radius: 20px;
    overflow: hidden;
    color: $color-white;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("/src/assets/images/venous-center-mobile-heading.webp");

    .heading-description {
      margin: $spacing-2 0 $spacing-4;
      width: 50%;
      text-align: center;
    }

    .heading-title {
      font-size: $title-h2;
      text-align: center;
    }
  }
}

.title {
  font-size: $title-h5;
  line-height: 1;
  margin-bottom: $spacing-3;
  font-family: $font-bold;
}

.grid-container {
  display: flex;
  flex-wrap: wrap;

  .grid-item-5-2 {
    flex: 1 0 50%; /* proportion of the available space */
    max-width: 50%;
  }

  .inner-grid-item {
    margin: $spacing-1;
    overflow: hidden;
    border-radius: 20px;

  }
}

.thumbnails-wrapper {
  position: relative;
  z-index: 22;
  background: $color-grey;
  overflow: hidden;
  color: $color-brown;


}

.services-wrapper, .thumbnails-wrapper {
  padding: $spacing-10 0;
}


.highlight-box-wrapper, .heading-wrapper, .equipment-wrapper {
  margin-bottom: $spacing-10;
}

@media screen and (min-width: 768px) {
  .page-wrapper {
    margin-top: 140px;
  }
  .heading-wrapper {
    .venous-center-heading-image {
      border-radius: 50px;
      background-image: url("/src/assets/images/venous-center-heading.webp");
    }
  }
  .title {
    font-size: $title-h3;
    line-height: $title-h3;
    width: 60%;
    margin-bottom: $spacing-3;
  }

  .grid-container {
    margin-top: $spacing-5;

    .grid-item-5-2 {
      flex: 1 0 20%; /* proportion of the available space */
      max-width: 20%;
    }
  }
  .thumbnails-wrapper {
    .description {
      width: 70%;
      font-size: $paragraph-1;
    }
  }
}

.modal-content-title {
  margin-bottom: 20px;
  font-family: $font-bold;
}

.modal-content-body {
  max-height: 320px;
  overflow: auto;
}
</style>